import React, { useEffect, useState, useCallback } from 'react';
import { Field, Form, getIn, withFormik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormikRangePicker, FormikSelect } from '../../../components';
import { debounceIndexSelectEmployeesRequest } from '../../../requests/employees';

const AuthorizeFilters = props => {
  const { values, errors, touched, setFieldValue, setFieldTouched, isArial, isSubmit, currentEmployee } = props;
  const ALL_SELECTED_LABEL = 'Todos';
  const [employees, setEmployees] = useState([]);
  const [dataRange, setDataRange] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);
  const [ruts, setRuts] = useState([]);
  const dispatch = useDispatch();

  const fetchEmployees = useCallback(() => {
    setFieldValue('employee_ids', []);
    setFieldValue('employee_id', '');
    setEmployees([]);
    setIsFiltering(true);
    debounceIndexSelectEmployeesRequest({
      dispatch,
      params: {
        sort_column: 'name',
        paginate: false,
        is_dt: false,
        employees_belong_boss: currentEmployee,
        filter_by_contract_date_range: dataRange
      },
      successCallback: ({ data: { data: arrayEmployees } }) => {
        const dataToGroupSearch = [{ id: '', label: 'Todos', value: '' }, ...arrayEmployees];
        setEmployees(arrayEmployees.length > 0 ? dataToGroupSearch : []);
        const employeeIds = arrayEmployees.flatMap(employee => employee.id);
        setFieldValue('all_employee_ids', employeeIds);
        setIsFiltering(false);
        if (!ruts[0]) {
          setRuts(arrayEmployees.map(r => r.national_identification));
        }
      }
    });
  }, [dispatch, currentEmployee, dataRange, ruts, setFieldValue]);

  const handleNewMulti = (data, field, allowEmpty = false) => {
    const newData = data.map(element => element.value);
    if (allowEmpty && !newData.length) newData.push('');
    setFieldValue(field, newData);
  };

  const hasAllSelection = (groupSelection = []) => {
    return groupSelection.some(option => option.label === ALL_SELECTED_LABEL);
  };

  const handleDisabledSelection = (options, selectedOptions) => {
    if (hasAllSelection(selectedOptions)) {
      return true;
    }
    if (selectedOptions.length === 0) return false;
    return options.label === ALL_SELECTED_LABEL;
  };

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return (
    <>
      <Form className="reports_filter__overflow">
        <>
          <Row>
            <Col className="mt-2">
              <Card className="card-dt">
                <Card.Body className="div-content company_reports card-body-padding__company_reports">
                  <Row>
                    <Col sm={12} md={6} xs={12}>
                      <Field name="range_date_workday">
                        {({ field }) => (
                          <FormikRangePicker
                            {...field}
                            abbr
                            startDateName="date_from_workday"
                            endDateName="date_to_workday"
                            startDate={values.date_from_workday}
                            endDate={values.date_to_workday}
                            showClearDates
                            error={getIn(errors, field.name)}
                            touched={getIn(touched, field.name)}
                            isArial={isArial}
                            onDatesChange={({ startDate: startDateV, endDate: endDateV }) => {
                              const startValue = moment.isMoment(startDateV) ? startDateV.format('DD/MM/YYYY') : '';
                              const endValue = moment.isMoment(endDateV) ? endDateV.format('DD/MM/YYYY') : '';

                              setFieldValue('employee', '');
                              setFieldValue('employees', []);

                              if (startValue && endValue) setDataRange([startValue, endValue]);

                              setFieldValue('date_from_workday', startValue);
                              setFieldValue('date_to_workday', endValue);
                              setFieldTouched(field.name);
                              setFieldValue(field.name, [startValue, endValue]);
                            }}
                          />
                        )}
                      </Field>
                    </Col>
                    <Col sm={12} md={4} xs={12}>
                      <Field name="employees">
                        {({ field }) => (
                          <FormikSelect
                            {...field}
                            label="Nombres y Apellidos"
                            isMulti
                            options={employees}
                            placeholder="Seleccione colaboradores"
                            isLoading={isFiltering}
                            onChange={data => {
                              handleNewMulti(data || [], 'employee_ids', true);
                              setFieldValue(field.name, data || []);
                              setFieldValue('employee', '');
                              setFieldValue('employee_id', '');
                            }}
                            isOptionDisabled={handleDisabledSelection}
                            isClearable
                            error={getIn(errors, field.name)}
                            touched={getIn(touched, field.name)}
                            isArial={isArial}
                          />
                        )}
                      </Field>
                    </Col>
                    <Col md={2} className="mt-4">
                      <Button
                        className={`btn-block ellipsis ${isArial ? 'arial-dt' : ''}`}
                        disabled={isSubmit}
                        type="submit"
                        onClick={() => {
                          setFieldValue('type', null);
                        }}
                      >
                        Filtrar
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      </Form>
    </>
  );
};

const validationSchema = Yup.object().shape({
  range_date_workday: Yup.array().rangedate(true)
});

const setInitialValues = () => {
  return {
    date_from_workday: '',
    date_to_workday: '',
    range_date_workday: [],
    employee_id: '',
    employee_ids: [],
    type: null,
    all_employee_ids: []
  };
};

const handleSubmit = (values, { props }) => {
  const allEmployeeIds = values.all_employee_ids.filter(id => id !== '');
  const { formRequest } = props;
  const filterIds = values.employee_ids.filter(id => id !== '');
  const {
    all_employee_ids: allEmployeeIdsNoFilter,
    employee,
    employees,
    date_from: dateFrom,
    date_to: dateTo,
    ...valuesWithoutUnwantedFields
  } = values;

  const employeesToFilter = filterIds.length > 0 ? filterIds : values.employee_id;
  formRequest({
    ...valuesWithoutUnwantedFields,
    filter_employee_ids: employeesToFilter || allEmployeeIds,
    filter_id: '',
    employee_id: '',
    employee_ids: []
  });
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: false
})(AuthorizeFilters);
